export const PATH_B2B_HOME = "/";
export const PATH_FLIGHTS_HOME = "/flights/";
export const PATH_AUTH_HOME = "/auth/";

export const PATH_START_SESSION = `${PATH_AUTH_HOME}startsession/`;
export const PATH_INVALID_SESSION = `${PATH_AUTH_HOME}invalidsession/`;
export const PATH_END_SESSION = `${PATH_AUTH_HOME}endsession/`;
export const FIRST_TIME_USER_EXPERIENCE_SESSION = `${PATH_AUTH_HOME}ftux/`;
